import { useSWRConfig } from 'swr';
import useSWRImmutable from 'swr/immutable';
import {
    getDensitiesFromAPI,
    getEnvironmentRangeFromApi,
    getTableConstraintsFromAPI,
} from '/@/store/product-datasheet/apiProviders';

export const useDensitiesForProduct = ({ id, crop }) => {
    const { cache } = useSWRConfig();
    let key = { id, crop, key: 'useDensitiesForProduct' };
    if (!id) key = null;
    return useSWRImmutable(key, ({ id, crop }) => getDensitiesFromAPI({ id, crop }, cache));
};

export const useDensitiesForProducts = ({ ids, crop }) => {
    const { cache } = useSWRConfig();
    const key = ids.length > 0 && crop ? { key: 'useDensitiesForProducts', ids, crop } : null;

    const { data, error, isLoading } = useSWRImmutable(key, async () => {
        const results = await Promise.all(
            ids.map(async (id) => {
                const result = await getDensitiesFromAPI({ id, crop }, cache);
                return { id, result };
            })
        );
        const dataObject = results.reduce((acc, { id, result }) => {
            acc[id] = result;
            return acc;
        }, {});

        return dataObject;
    });

    return {
        data,
        error,
        isLoading,
    };
};

export const useEnvironmentRangesFromApi = ({ ids, crop }) => {
    const { cache } = useSWRConfig();
    let key = { ids, crop, key: 'useEnvironmentRangesFromApi' };
    if (!ids) key = null;
    const { data, error, isLoading } = useSWRImmutable(key, async () => {
        const results = await Promise.all(
            ids.map(async (id) => {
                const result = await getEnvironmentRangeFromApi({ id, crop }, cache);
                return { id, result };
            })
        );
        const dataObject = results.reduce((acc, { id, result }) => {
            acc[id] = result;
            return acc;
        }, {});

        return dataObject;
    });

    return {
        data,
        error,
        isLoading,
    };
};

export const useTableConstraintsFromAPI = ({ product, crop }) => {
    const { cache } = useSWRConfig();
    let key = { product, crop, key: 'useTableConstraintsFromAPI' };
    if (!product || !crop) key = null;
    return useSWRImmutable(key, ({ product, crop }) => getTableConstraintsFromAPI({ product, crop }, cache));
};

export const useTablesConstraintsFromAPI = ({ ids, crop }) => {
    const { cache } = useSWRConfig();
    let key = { ids, crop, key: 'useTablesConstraintsFromAPI' };
    if (!ids || !crop) key = null;
    const { data, error, isLoading } = useSWRImmutable(key, async () => {
        const results = await Promise.all(
            ids.map(async (id) => {
                const result = await getTableConstraintsFromAPI({ id, crop }, cache);
                return { id, result };
            })
        );

        const dataObject = results.reduce((acc, { id, result }) => {
            acc[id] = result;
            return acc;
        }, {});

        return dataObject;
    });

    return {
        data,
        error,
        isLoading,
    };
};

export const useEnvironmentRangeFromApi = ({ id, crop }) => {
    const { cache } = useSWRConfig();
    let key = { id, crop, key: 'useEnvironmentRangeFromApi' };
    if (!id || !crop) key = null;
    return useSWRImmutable(key, ({ id, crop }) => getEnvironmentRangeFromApi({ id, crop }, cache));
};
